import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateCustomerDocuments } from '../../common/api/clients/supplierOnboarding.api';
import { queries } from '../../common/api/queryKeys/queries';

interface UpdateCustomerDocumentsVariables {
    offerId: string;
    fileIds: string[];
}

export const useUpdateCustomerDocuments = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ offerId, fileIds }: UpdateCustomerDocumentsVariables) =>
            updateCustomerDocuments(offerId, fileIds),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.supplierOnboarding._def,
            });
        },
    });
};
